<!--
 * @Description:批量导入
 * @Date: 2023/4/20 下午3:41:37
-->
<template>
  <base-dialog
    width="436px"
    :visible="true"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    title="添加人员"
  >
    <div style="padding: 20px">
      <p style="color: var(--xrk-color-primary); margin-top: 16px">
        注：添加人员只能是“已导入项目的人员”
      </p>
      <BaseUpload
        v-model:fileList="formData.fileList"
        style="width: 400px; display: inline-block"
        ref="upload"
        listType="text"
        :limit="1"
        :limit-size="3"
        :accept="['xls', 'xlsx']"
        :httpRequest="httpRequest"
        :auto-upload="true"
        :onError="onError"
        btnText="上传人员名单"
      >
        <template #tip>
          <p style="line-height: 20px; margin-top: 15px">
            只能上传xls或xlsx文件
          </p>
        </template>
      </BaseUpload>
    </div>

    <BaseButton
      style="margin-left: 20px"
      type="text"
      :icon="Download"
      @click="downLoadTempLate"
    >
      名单模板下载
    </BaseButton>
    <template #footer>
      <BaseButton @click="onCancel" type="default">取消</BaseButton>
      <BaseButton :click="onConfirm" type="primary">确认导入</BaseButton>
    </template>
  </base-dialog>
</template>
<script lang="tsx" setup>
import {
  defineProps,
  withDefaults,
  reactive,
  ref,
  computed,
  defineEmits
} from 'vue';
import {
  BaseButton,
  BaseDialog,
  BaseUpload,
  XrkMessage,
  createDialog
} from 'xrk-components';
import { Download } from '@element-plus/icons-vue';
import {
  batchAddActivityPeople,
  downloadTemplate,
  againSubmit
} from '../data-source/apis';
import { uploadApi } from '@data-source/common/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import AddPersonFailTable from './add-person-fail-table.vue';
const store = useProjectDetailStore();

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    activityId: number;
    importType: number;
  }>(),
  {
    remove() {
      return () => ({});
    },
    activityId: null,
    importType: null
  }
);
const emits = defineEmits(['success']);

const projectInfo = computed(() => store.baseData.projectInfo);

const upload = ref(null);

const formData = reactive({
  fileList: []
});
const onCancel = () => {
  props.remove();
};

const excelCode = ref('');

//生成唯一id
function generateUniqueId() {
  return Date.now().toString(36) + Math.random().toString(36).substr(2, 9);
}

const againSubmitPerson = async (inVO, dataList) => {
  try {
    inVO = JSON.parse(inVO);
  } catch (error) {
    //
  }
  const { data } = await againSubmit({ inVO, dataList });
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: false,
      showFooter: false,
      contentRender: done => {
        return (
          <AddPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
              done();
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></AddPersonFailTable>
        );
      }
    });
    props.remove();
  }
};

const onConfirm = async () => {
  if (formData.fileList.length <= 0) {
    XrkMessage.error('请先上传文件！');
    return;
  }
  excelCode.value = generateUniqueId();
  const inVO = {
    projectId: projectInfo.value.id,
    activityId: props.activityId,
    importType: props.importType,
    excelCode: excelCode.value,
    excelUploadUrl: formData.fileList[0].url,
    excelName: formData.fileList[0].name
  };
  const params = {
    inVO: JSON.stringify(inVO),
    file: formData.fileList[0].raw
  };

  const { data } = await batchAddActivityPeople(params);
  if (data.failCount === 0) {
    XrkMessage.success('导入成功');
    emits('success');
    props.remove();
  } else {
    createDialog({
      width: '1300px',
      title: '导入失败',
      showClose: false,
      showFooter: false,
      contentRender: done => {
        return (
          <AddPersonFailTable
            form={{
              excelCode: excelCode.value
            }}
            onAgainSubmit={async ({ dataList }) => {
              await againSubmitPerson(inVO, dataList);
              done();
            }}
            importCount={data.importCount}
            failCount={data.failCount}
            dataList={data.dataList}
            done={done}
          ></AddPersonFailTable>
        );
      }
    });
    props.remove();
  }
};
const httpRequest = ({ file }) => {
  return uploadApi({ file });
};
const onError = errorInfo => {
  XrkMessage.error(errorInfo.msg);
};
//名单模板下载
function downLoadTempLate() {
  downloadTemplate({ excelGroupCode: 'activity_participants' });
}
</script>
